<template>
  <ca-modal
    ref="modal"
    size="small"
    title="Necessário aprovar Dados do Contrato"
    :on-close="close">
    <template slot="body">
      <ca-row>
        <ca-col>
          Para realizar essa ação, primeiro é necessário a aprovação da
          etapa Dados de Contrato. Deseja visualizar os Dados de contrato agora?
        </ca-col>
      </ca-row>
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="close">
          Cancelar
        </ca-button>
      </ca-col>
      <ca-col offset="4" size="5">
        <ca-button
          theme="primary"
          full-width
          @click="onViewContractData">
          Visualizar Dados de Contrato
        </ca-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
export default {
  name: 'EditPendingContractlDataAlert',
  methods: {
    onViewContractData() {
      this.close();
      this.$emit('on-view-contract-data');
    },
    close() {
      this.$emit('on-cancel');
      this.$refs.modal.close();
    },
  },
};
</script>
